<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" class="icon-filters" viewBox="0 0 14.92 14.97"><g><g><line class="cls-line" x1="14.17" y1="7.49" x2="0.75" y2="7.49"/><line class="cls-line" x1="0.75" y1="12.19" x2="14.17" y2="12.19"/><line class="cls-line" x1="0.75" y1="2.79" x2="14.17" y2="2.79"/><circle class="cls-1" cx="12.14" cy="7.49" r="2.04"/><circle class="cls-1" cx="2.79" cy="12.19" r="2.04"/><circle class="cls-1" cx="2.79" cy="2.79" r="2.04"/></g></g></svg>
</template>
<script>
  export default {
    name: 'IconFilters',
  };
</script>
